// Textos da tela de login que mudam entre o portal e a intranet. O resto da
// tela (Login.jsx e login.css) é igual nos dois repositórios.
const textos = {
  // No portal o login é o e-mail (use_email_as_login ligado).
  rotuloUsuario: 'E-mail',
  // Teclado do celular: com @ à vista.
  teclado: 'email',
  chamada: 'Acesso restrito à equipe que publica no portal.',
};

export default textos;
